import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {ModalService} from '../../../services/modal/modal.service';

@Component({
    selector: 'app-buttons-bank-alert',
    templateUrl: './buttons-bank-alert.component.html',
    styleUrls: ['./buttons-bank-alert.component.scss']
})
export class ButtonsBankAlertComponent implements OnInit {
    @Input('isDisabled') public isDisabled = false;

    @Input('styleView') public styleView = 'horizontal'; /* horizontal/vertical */

    constructor(
        protected modalService: ModalService,
    ) {
    }

    ngOnInit(): void {
    }

    showModal(content: TemplateRef<any>): void {
        this.modalService.openTemplateModal(content, 'sm');
    }
}
